import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CronogramaEscolar.css';

const CronogramaEscolar = () => {
  const [cronograma, setCronograma] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    titulo: '',
    descricao: '',
    dataInicio: '',
    dataFim: '',
    tipo: 'atividade',
    prioridade: 'media'
  });
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    fetchCronograma();
  }, []);

  const fetchCronograma = async () => {
    try {
      const response = await axios.get('/api/cronograma');
      setCronograma(response.data.cronograma || []);
    } catch (error) {
      console.error('Erro ao buscar cronograma:', error);
      // Dados mock para demonstração
      setCronograma([
        {
          id: 1,
          titulo: 'Prova de Matemática',
          descricao: 'Conteúdo: Álgebra e Geometria',
          dataInicio: '2024-02-15',
          dataFim: '2024-02-15',
          tipo: 'prova',
          prioridade: 'alta'
        },
        {
          id: 2,
          titulo: 'Entrega de Trabalho de História',
          descricao: 'Tema: Revolução Industrial',
          dataInicio: '2024-02-20',
          dataFim: '2024-02-20',
          tipo: 'trabalho',
          prioridade: 'media'
        },
        {
          id: 3,
          titulo: 'Reunião de Pais',
          descricao: 'Discussão sobre desempenho dos alunos',
          dataInicio: '2024-02-25',
          dataFim: '2024-02-25',
          tipo: 'reuniao',
          prioridade: 'baixa'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (editingItem) {
        await axios.put(`/api/cronograma/${editingItem.id}`, formData);
      } else {
        await axios.post('/api/cronograma', formData);
      }
      
      fetchCronograma();
      resetForm();
    } catch (error) {
      console.error('Erro ao salvar item:', error);
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      titulo: item.titulo,
      descricao: item.descricao,
      dataInicio: item.dataInicio,
      dataFim: item.dataFim,
      tipo: item.tipo,
      prioridade: item.prioridade
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este item?')) {
      try {
        await axios.delete(`/api/cronograma/${id}`);
        fetchCronograma();
      } catch (error) {
        console.error('Erro ao excluir item:', error);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      titulo: '',
      descricao: '',
      dataInicio: '',
      dataFim: '',
      tipo: 'atividade',
      prioridade: 'media'
    });
    setEditingItem(null);
    setShowForm(false);
  };

  const getPrioridadeColor = (prioridade) => {
    switch (prioridade) {
      case 'alta': return '#ef4444';
      case 'media': return '#f59e0b';
      case 'baixa': return '#10b981';
      default: return '#6b7280';
    }
  };

  const getTipoIcon = (tipo) => {
    switch (tipo) {
      case 'prova': return '📝';
      case 'trabalho': return '📚';
      case 'reuniao': return '👥';
      case 'atividade': return '🎯';
      default: return '📅';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="cronograma-loading">
        <div className="loading-spinner"></div>
        <p>Carregando cronograma...</p>
      </div>
    );
  }

  return (
    <div className="cronograma-container">
      <div className="cronograma-header">
        <h1>📅 Cronograma Escolar</h1>
        <p>Planeje e acompanhe o cronograma de atividades, conteúdos programáticos e prazos importantes do ano letivo.</p>
        <button 
          className="add-button"
          onClick={() => setShowForm(true)}
        >
          <span className="add-icon">+</span>
          Adicionar Atividade
        </button>
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>{editingItem ? 'Editar Atividade' : 'Nova Atividade'}</h2>
              <button className="close-button" onClick={resetForm}>×</button>
            </div>
            
            <form className="cronograma-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="titulo">Título *</label>
                  <input
                    type="text"
                    id="titulo"
                    name="titulo"
                    value={formData.titulo}
                    onChange={(e) => setFormData({...formData, titulo: e.target.value})}
                    required
                    placeholder="Ex: Prova de Matemática"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="tipo">Tipo</label>
                  <select
                    id="tipo"
                    name="tipo"
                    value={formData.tipo}
                    onChange={(e) => setFormData({...formData, tipo: e.target.value})}
                  >
                    <option value="atividade">Atividade</option>
                    <option value="prova">Prova</option>
                    <option value="trabalho">Trabalho</option>
                    <option value="reuniao">Reunião</option>
                  </select>
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="descricao">Descrição</label>
                <textarea
                  id="descricao"
                  name="descricao"
                  value={formData.descricao}
                  onChange={(e) => setFormData({...formData, descricao: e.target.value})}
                  placeholder="Detalhes sobre a atividade..."
                  rows={3}
                />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="dataInicio">Data de Início *</label>
                  <input
                    type="date"
                    id="dataInicio"
                    name="dataInicio"
                    value={formData.dataInicio}
                    onChange={(e) => setFormData({...formData, dataInicio: e.target.value})}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="dataFim">Data de Término *</label>
                  <input
                    type="date"
                    id="dataFim"
                    name="dataFim"
                    value={formData.dataFim}
                    onChange={(e) => setFormData({...formData, dataFim: e.target.value})}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="prioridade">Prioridade</label>
                  <select
                    id="prioridade"
                    name="prioridade"
                    value={formData.prioridade}
                    onChange={(e) => setFormData({...formData, prioridade: e.target.value})}
                  >
                    <option value="baixa">Baixa</option>
                    <option value="media">Média</option>
                    <option value="alta">Alta</option>
                  </select>
                </div>
              </div>
              
              <div className="form-actions">
                <button type="button" className="cancel-button" onClick={resetForm}>
                  Cancelar
                </button>
                <button type="submit" className="save-button">
                  {editingItem ? 'Atualizar' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="cronograma-content">
        {cronograma.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📅</div>
            <h3>Nenhuma atividade cadastrada</h3>
            <p>Comece adicionando atividades ao cronograma escolar.</p>
            <button 
              className="add-button"
              onClick={() => setShowForm(true)}
            >
              Adicionar Primeira Atividade
            </button>
          </div>
        ) : (
          <div className="cronograma-grid">
            {cronograma.map((item) => (
              <div key={item.id} className="cronograma-card">
                <div className="card-header">
                  <div className="card-icon">
                    {getTipoIcon(item.tipo)}
                  </div>
                  <div className="card-title-section">
                    <h3>{item.titulo}</h3>
                    <span 
                      className="priority-badge"
                      style={{ backgroundColor: getPrioridadeColor(item.prioridade) }}
                    >
                      {item.prioridade.toUpperCase()}
                    </span>
                  </div>
                  <div className="card-actions">
                    <button 
                      className="edit-button"
                      onClick={() => handleEdit(item)}
                      title="Editar"
                    >
                      ✏️
                    </button>
                    <button 
                      className="delete-button"
                      onClick={() => handleDelete(item.id)}
                      title="Excluir"
                    >
                      🗑️
                    </button>
                  </div>
                </div>
                
                <div className="card-description">
                  {item.descricao}
                </div>
                
                <div className="card-dates">
                  <div className="date-item">
                    <span className="date-label">Início:</span>
                    <span className="date-value">{formatDate(item.dataInicio)}</span>
                  </div>
                  <div className="date-item">
                    <span className="date-label">Término:</span>
                    <span className="date-value">{formatDate(item.dataFim)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CronogramaEscolar;
